module.exports = __webpack_public_path__ + "img/Flag_of_Jersey.d45e9004.svg";